var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 26.7649L26.3647 22.1129C24.7129 22.2404 23.5059 21.9005 22.7435 21.0933C21.9812 20.2861 21.5153 19.2028 21.3459 17.8433C21.1765 16.4838 21.1341 15.0181 21.2188 13.4462H27V0H16.1365V15.9952C16.1365 19.9038 17.1106 22.8352 19.0588 24.7894C21.0494 26.7437 23.6965 27.4022 27 26.7649ZM10.8635 26.7649L10.2282 22.1129C8.57647 22.2404 7.36941 21.9005 6.60706 21.0933C5.84471 20.2861 5.37882 19.2028 5.20941 17.8433C5.04 16.4838 4.99765 15.0181 5.08235 13.4462H10.8635V0H0V15.9952C0 19.9038 0.974118 22.8352 2.92235 24.7894C4.91294 26.7437 7.56 27.4022 10.8635 26.7649Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.a50f608800541babb841c3ac6a8b3ebd.svg";
export { ForwardRef as ReactComponent };